
























import Vue from 'vue'
import { mapGetters } from 'vuex'
import { DispatchingCreditService } from '@/api/services/dispatching-credit'

export default Vue.extend({
  data() {
    return {
      loading: false,
      columns: [
        {
          label: 'N° transaction',
          field: 'transaction.reference'
        },
        {
          label: 'Ligne de crédit',
          field: 'creditLine.name'
        },
        {
          label: 'Nom initiateur',
          field: 'fullname'
        },
        {
          label: 'Date/Heure',
          field: 'createdAt',
          datetime: true
        },
        {
          label: 'Montant',
          field: 'amount',
          currency: true
        },
        {
          label: 'Numéro de téléphone',
          field: 'beneficiary.phone'
        },
        {
          label: 'Opérateur Mobile',
          field: 'otm'
        }
        // {
        //   label: 'Actions',
        //   field: '_actions',
        //   align: 'left'
        // }
      ],
      rows: [],
      total: 0,
      pagination: {
        page: 1,
        perPage: 10
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['user'])
  },

  async created() {
    this.loading = true
    await this.fetchData()
    this.loading = false
    // DispatchingCredit.api()
    //   .fetchForOrganization()
    //   .then(() => {
    //     this.loading = false
    //   })
    //   .catch((error: Error) => {
    //     console.error(error)
    //     this.loading = false
    //   })
  },

  methods: {
    async fetchData(this: any) {
      const response = await DispatchingCreditService.findAll(
        this.$route.params.productId,
        this.pagination,
        this.user.organizationId
      )
      this.rows = response.result
      this.total = response.count
    },

    onPrev() {
      if (this.pagination.page > 1) {
        this.pagination.page--
        this.fetchData()
      }
    },

    onNext() {
      if (
        this.total &&
        this.pagination.page * this.pagination.perPage < this.total
      ) {
        this.pagination.page++
        this.fetchData()
      }
    }
  }
})
